export const getPlanAreaDTO = (areaData) => {
    const planAreaDTO = {
        planUUID: areaData.plan.planUUID,
        planAreaId: areaData.areaId,
    };
    return planAreaDTO;
}

export const getPlanAreaDTOs = (areasData) => {
    const planAreaDTOs = areasData.map(area => getPlanAreaDTO(area));
    return planAreaDTOs;
}
